<template>
  <div
    v-loading="isClassificationInProgress"
    class="classify-controls"
    @mouseover="hovering = true"
    @mouseout="hovering = false"
  >
    <div>
      <el-dropdown
        v-if="user.role !== 'STARTUP'"
        split-button
        type="primary"
        :size="btnSize"
        :show-timeout="0"
        @click="openRateDialog()"
        @command="openRateDialog()"
      >
        <template v-if="ratingValue">
          Rated {{ ratingValue }}<i class="ion ion-star"></i>
        </template>
        <template v-else>
          Rate
        </template>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="rate">
            Change rating
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <ConnectWithStartup
        v-if="user.isInvestorOrOrganizer && startup.id"
        :startup="startup"
        :org-id="user.organizationId"
      />
    </div>

    <RateDialog
      ref="rateDialog"
      :startup-id="startup.id"
      :title="`Rate ${startup.name}`"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import notifications from 'services/notifications'
import RateDialog from 'components/startups/RateDialog.vue'
import ConnectWithStartup from 'components/organizations/ConnectWithStartup'

export default {
  components: {
    RateDialog,
    ConnectWithStartup,
  },
  data() {
    return {
      btnSize: 'small',
      hovering: false,
      isRejectDialogVisible: false,
      rejectReasonOther: '',
      rejectReason: null,
      isSubmitRejectionInProgress: false,
    }
  },
  computed: {
    ratingValue() {
      return (
        this.startup.ratings &&
        this.startup.ratings.overall &&
        this.startup.ratings.overall.value
      )
    },
    showActions() {
      return !this.investor.state || this.investor.state === 'screening'
    },
    isInterested() {
      return this.investor.state === 'interested'
    },
    isRejectedOrNotInterested() {
      return ['not_interested', 'rejected'].includes(this.investor.state)
    },
    isNotDecidedYet() {
      return !this.investor.state || this.investor.state === 'screening'
    },
    ...mapState({
      user: (state) => state.user.data,
      investor: (state) => state.startupProfileInvestorClassifies.investor,
      startupId: (state) => state.startupProfileInvestorClassifies.startupId,
      linkId: (state) => state.startupProfileInvestorClassifies.linkId,
      isClassificationInProgress: (state) =>
        state.startupProfileInvestorClassifies.isClassificationInProgress,
      startup: (state) => state.startupProfile.startup,
    }),
  },
  methods: {
    async contactStartup() {
      const request = this.$store.dispatch(
        'startupProfileInvestorClassifies/contact',
        {
          investorId: this.investor.id,
          startupId: this.startupId,
          linkId: this.linkId,
        },
      )
      await request
      notifications.notify({ type: 'success', title: 'Submitted' })
    },

    onOtherFocus() {
      this.rejectReason = 'other'
    },

    openRateDialog() {
      this.$refs.rateDialog.open()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~assets/css/colors.scss';

.classified {
  p {
    margin-bottom: 2px;

    a:hover {
      text-decoration: none;
    }
  }
}

.rejection-reason-form {
  label {
    width: 100%;
  }
  .other-reason {
    .el-form-item__label {
      line-height: 20px;
    }
  }
}

.classify-controls {
  position: absolute;
  a {
    text-transform: none;
    font-weight: initial;
    padding: 4px;
    color: $grey60;

    &:hover {
      text-decoration: none;
      font-weight: initial;
      border-bottom: 1px solid $yellow;
    }
  }
}

@media screen and (max-width: 768px) {
  .classify-controls {
    top: -4px;
    display: flex;
    flex-direction: column;

    button {
      margin-bottom: 8px;
    }
  }

  .el-button + .el-button {
    margin-left: 0px;
  }
}
</style>
